import { useRef, type ReactNode } from 'react';
import { cn } from '@/shared/lib/cn';

interface Props {
  onCapture: (file: File) => void;
  disabled?: boolean;
  className?: string;
  children: ReactNode;
}

/**
 * Triggert die Live-Kamera über ein verstecktes `<input capture="environment">`.
 * Auf dem Handy öffnet das direkt die Rückkamera; am Desktop einen Datei-Picker
 * (Server-Empfangszeit ist der eigentliche „Jetzt"-Beweis — Block-Scope „keine native App").
 * `key`-Reset über value='' erlaubt erneutes Wählen derselben Datei (Retake).
 */
export function CameraCaptureButton({ onCapture, disabled, className, children }: Props) {
  const inputRef = useRef<HTMLInputElement>(null);
  return (
    <>
      <button
        type="button"
        disabled={disabled}
        onClick={() => inputRef.current?.click()}
        className={cn('disabled:opacity-50', className)}
      >
        {children}
      </button>
      <input
        ref={inputRef}
        type="file"
        accept="image/*"
        capture="environment"
        className="hidden"
        onChange={(e) => {
          const file = e.target.files?.[0];
          if (file) onCapture(file);
          e.target.value = '';
        }}
      />
    </>
  );
}
